module.exports = __webpack_public_path__ + "static/media/Oscar_C_img.7d7c2229.jpg";